import React, { useState } from "react";

const ImportCell = ({ value, valid, modifyValue }) => {
  const [newValue, setNewValue] = useState(value);
  return (
    <td
      style={{
        backgroundColor: valid ? null : "#ffcccb",
      }}
    >
      <div
        className="p-3"
        contentEditable="true"
        onInput={(e) => setNewValue(e.currentTarget.textContent)}
        onBlur={() => (newValue != value ? modifyValue(newValue) : {})}
        suppressContentEditableWarning={true}
      >
        {value}
      </div>
    </td>
  );
};

export default React.memo(ImportCell);
